/* ========================== */  
/* ========= import ========= */  
/* ========================== */  

/* ====== React ====== */
import React from "react"
import AnchorLink from "react-anchor-link-smooth-scroll";

/* ====== CSS ====== */
import styled from 'styled-components';

/* ====== Component Js/Jsx ====== */
import { assets } from "03CommonApiParts/Configuration";


/* ========================== */  
/* ========= Styles ========= */  
/* ========================== */  

/* ====== Styled Components ====== */
/* ------ アンカー ------*/
const SdivAnker = styled.div`//アンカー枠
    color: ${props =>props.status === props.active ? '#2E94B9': '#BDBDBD'};
    border: ${props =>props.status === props.active ? '1px solid #2E94B9': '1px solid #BDBDBD'};
	background-color: white;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
	transition: all ease-in-out .2s;
    &:hover{
        color: ${props =>props.status === props.active ? 'white': ''};
        background-color:${props =>props.status === props.active ? '#2E94B9': '#white'};
	};
`;

// 使い方
//1:もとにするデータ
//2:アンカーのコンテンツ

// const anchorContents = [
//     {id:'inquiryState', name:'問合せ情報',  status:'inquiryState'},
//     {id:'reception',    name:'受付情報',    status:'inquiryState'},
//     {id:'corresp',      name:'対応情報',    status:'receptionedState'},
//     {id:'doneCorresp',  name:'対応完了情報',status:'receptionedState'},
//     {id:'test',         name:'検査情報',    status:'correspondencedState'},
//     {id:'comemnt',      name:'コメント',    status:'inquiryState'},
// ]
// <Anchor dataRow={dataRow} contents={anchorContents}/>

/* ========================== */  
/* ========== Main ========== */  
/* ========================== */  

export const Anchor = (props) => {
    /* ========================== */  
    /* ========== valiables ========== */  
    /* ========================== */ 
    // const { dataRow,contents } = props;
    const { contents } = props;

    /* ========================== */  
    /* ====== Start Render ====== */  
    /* ========================== */  
    return (
        contents.map((items) => {
            /* dataRowに入っているステータス情報の中からアンカーコンテンツに入っているステータスを検索する。検索した値をactiveValueに入れる。*/
            const activeValue = items.id;
            return(
            <AnchorLink key={items.id} href={`#${items.id}`} offset='100'>
                <SdivAnker 
                    className='anchorStyle' 
                    style={{fontSize:assets().size.baseText,width:assets().size.anchorWidth,height:assets().size.anchorHeight}}
                    status={items.status} active={activeValue ? activeValue : ''}>
                    {items.name}
                </SdivAnker>
            </AnchorLink>
        )})

    );
};






